module.exports = __webpack_public_path__ + "static/media/30-1.0a8e984a.mp3";